import React from "react";
import ContactForm from "./ContactForm";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const SectionContact = () => {
  const { siteSetting } = useSelector((state) => state.setting);
  const socialData = [
    {
      _id: 1,
      name: "Linkedin",
      iconClass: "fa-brands fa-linkedin-in",
      link: "/",
    },
    {
      _id: 2,
      name: "Instagram",
      iconClass: "fa-brands fa-instagram",
      link: "/",
    },
    {
      _id: 3,
      name: "Facebook",
      iconClass: "fa-brands fa-facebook-f",
      link: "/",
    },
    { _id: 4, name: "Twitter", iconClass: "fa-brands fa-x-twitter", link: "/" },
  ];
  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24 bg-chestnut-rose">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="block xls:flex items-center justify-between gap-10">
            <div className="flex flex-col flex-shrink-0 w-full max-w-none xls:max-w-sm 1xl:max-w-xl text-white space-y-10">
              <h2 className="text-3xl md:text-5xl font-bold">
                Connect with Us
              </h2>
              <div className="space-y-2 md:space-y-6">
                {(siteSetting?.title || siteSetting?.address) && (
                  <div className="flex items-center md:items-start gap-5 md:gap-10">
                    <div className="flex items-center justify-center flex-shrink-0 aspect-square w-10 text-3xl">
                      <i className="fa-regular fa-fw fa-mailbox-flag-up"></i>
                    </div>
                    <div className="text-base md:text-xl !leading-relaxed">
                      {siteSetting?.title}
                      <br />
                      {siteSetting?.address}
                    </div>
                  </div>
                )}
                {siteSetting?.officeHours && (
                  <div className="flex items-center md:items-start gap-5 md:gap-10">
                    <div className="flex items-center justify-center flex-shrink-0 aspect-square w-10 text-3xl">
                      <i className="fa-regular fa-fw fa-clock"></i>
                    </div>
                    <div className="text-base md:text-xl !leading-relaxed">
                      {siteSetting?.officeHours}
                    </div>
                  </div>
                )}

                {siteSetting?.email && (
                  <div className="flex items-center md:items-start gap-5 md:gap-10">
                    <div className="flex items-center justify-center flex-shrink-0 aspect-square w-10 text-3xl">
                      <i className="fa-regular fa-fw fa-envelope"></i>
                    </div>
                    <div className="text-base md:text-xl !leading-relaxed">
                      <Link
                        to="mailto:contact@vpeters.org"
                        className="flex items-start gap-10"
                      >
                        <span className="underline text-white">
                          {siteSetting?.email}
                        </span>
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              {siteSetting?.social?.length > 0 && (
                <div className="relative flex gap-3 xls:gap-5 items-center">
                  {siteSetting?.social?.map((item, index) => (
                    <a
                      key={index}
                      href={item?.url}
                      target="_blank"
                      rel="noreferrer"
                      className="w-10 xls:w-12 aspect-square rounded-lg bg-white hover:bg-chestnut-rose duration-300 hover:text-white flex items-center justify-center text-lg xls:text-2xl text-chestnut-rose"
                      title={item?.name}
                    >
                      <i className={item?.icon}></i>
                    </a>
                  ))}
                </div>
              )}
            </div>
            <div className="flex flex-col flex-shrink-0 w-full max-w-none xls:max-w-xl mt-10">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionContact;
